import { Stack, Typography } from "@mui/material";
import { ToolType } from "src/api/services/askApi";
import LinkIcon from "@mui/icons-material/Link";
import ToolDescription from "../ToolDescription";

interface Props {
  tools: ToolType[];
  runDone: boolean;
}

const ToolsDescription = ({ tools, runDone }: Props) => {
  return (
    tools.length > 0 && (
      <Stack spacing={1.25}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <LinkIcon sx={{ fontSize: 18, color: "text.secondary" }} />
          <Typography
            variant="body2"
            sx={{ fontWeight: 500, color: "text.secondary" }}
          >
            Tools / queries used
          </Typography>
        </Stack>

        {tools.map((t) => (
          <ToolDescription key={t.callId} tool={t} runDone={runDone} />
        ))}
      </Stack>
    )
  );
};

export default ToolsDescription;
